import iconComponents from '@/assets/icons/iconComponents'
import React, { AllHTMLAttributes, useEffect, useState } from 'react'

interface ICheckbox extends AllHTMLAttributes<HTMLInputElement> {
  checkComponent?: React.ReactElement
  uncheckedComponent?: React.ReactElement
  indeterminate?: boolean
}

function Checkbox(props: ICheckbox) {
  const {
    onChange,
    checked: passCheck,
    checkComponent,
    uncheckedComponent,
    indeterminate,
    id,
    ...rest
  } = props
  const [checked, setChecked] = useState(passCheck)

  useEffect(() => {
    setChecked(passCheck)
  }, [passCheck])

  const changeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(e.currentTarget.checked)
    onChange?.(e)
  }

  return (
    <div className='cursor-pointer relative'>
      {/* Hidden Native Checkbox */}
      <input
        type='checkbox'
        id={id}
        checked={checked}
        onChange={changeHandler}
        hidden
        {...rest}
        className='opacity-0 absolute h-8 w-8 outline-none border-none peer'
      />

      {/* Custom Accessible Checkbox */}
      <div
        role='checkbox'
        aria-checked={indeterminate ? 'mixed' : checked}
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            changeHandler({ currentTarget: { checked: !checked } } as any)
          }
        }}
        onClick={() => setChecked(!checked)}
      >
        {checkComponent && uncheckedComponent ? (
          indeterminate ? (
            <iconComponents.util.Indeterminatecon aria-hidden='true' />
          ) : checked ? (
            checkComponent
          ) : (
            uncheckedComponent
          )
        ) : indeterminate ? (
          <iconComponents.util.Indeterminatecon aria-hidden='true' />
        ) : checked ? (
          <iconComponents.util.CheckedIcon aria-hidden='true' />
        ) : (
          <iconComponents.util.UncheckedIcon aria-hidden='true' />
        )}
      </div>
    </div>
  )
}

export default Checkbox
